import '../../core/components/chart-grid/ChartGrid.css';
import './XYChartLayout.css';
export var datapointCanvasPlot = '_1ru1qe71-3-15-1 _13lzg4k0-3-15-1 _1ru1qe70-3-15-1';
export var rectangleCanvasPlot = '_13lzg4k0-3-15-1 _1ru1qe70-3-15-1';